<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCrown } from '@fortawesome/free-solid-svg-icons';
    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = false
    let bnakDep = {}
    let names;

    let camList = []
    let isList=  false

    async function campaignList() {
        isList = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/promotionlist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            camList = json.payload
            isList = true
		} else {

            throw new Error(json);
		}
    }
    $: {
        campaignList()
    }
</script>
<div class="default-home">
<div class="row   mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; bacbackground-repeat: no-repeat;
background-attachment: fixed;
background-position: center;">
    <Header />
    
   
    <div class="col-12 text-center mt-2" ><h4 class="header-n"><Fa icon={faCrown} /> โปรโมชั่น</h4></div>
    <div class="col-12" style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        <div class="card mt-2 bg-black">
            <div class="card-body text-center">
                <div class="row ps-2 pe-2">
                    {#if isList} 
                    {#each camList as gms}
                    <div class="col-12 border border-1 border-warning rounded p-2 text-center mb-2">
                        
                        
                        <div class="row">
                            <div class="col-12 text-center text-white">
                                <h6 class="text-warning">{gms.promotion_name}</h6>
                                {#if gms.promotion_image!=''}
                                <img class="img-fluid" src="{gms.promotion_image}" />
                                {:else}
                                {gms.promotion_desc}
                                {/if}
                                
                                
                            </div>
                            <div class="col-6 ">
                                <button type="button" class="btn btn-dark btn-sm border-1 border-warning w-100 mb-2" on:click={() => push('/promotion/'+gms._id)}>รายละเอียด</button>
                            </div>
                            <div class="col-6 ">
                                <button type="button" class="btn btn-warning btn-sm w-100" on:click={() => push('/promotion/'+gms._id)}>รับโปรโมชั่น</button>
                            </div>
                            <!-- <div class="col-4 ">
                                
                                {#if gms.member_used==0}
                                <button type="button" class="btn btn-dark btn-sm border-1 border-warning w-100 mb-2" on:click={() => push('/promotion/'+gms._id)}>รายละเอียด</button>
                                    {#if gms.is_code==0}
                                    <button type="button" class="btn btn-warning btn-sm w-100" on:click={() => push('/promotionapply/'+gms._id)}>รับคูปอง</button>
                                    {:else}
                                    <button type="button" class="btn btn-outline-warning btn-sm w-100" on:click={() => push('/promotionapply/'+gms._id)}>Code</button>
                                    {/if}
                                {:else}
                                    {#if gms.campaign_type==2 || gms.campaign_type==3 }
                                    <a href="/luckywheel?id={gms._id}" target="_blank"  class="btn btn-light btn-sm border-1 border-warning w-100 mb-2">เล่นเกม</a>
                                    {/if}
                                    <span class="text-success">ใช้งานแล้ว</span>
                                    
                                {/if}
                            </div> -->
                        </div>
                    </div>
                    {/each}
                    {/if}
                </div>
                
            </div>
        </div>
        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-promotion">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4 class="head-title"><Fa icon={faCrown} /> โปรโมชั่น</h4></div>
            <div class="col-12" style="min-height: 500px;">
                {#if loading}
                <div class="text-center mt-2" style="">
                    <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
                </div>
                {/if}
                {#if !loading}
                <div class="card mt-3 bg-black">
                    <div class="card-body text-center">
                        <div class="row ps-2 pe-2">
                            {#if isList} 
                            {#each camList as gms}
                            <div class="col-12 border border-1 border-warning rounded p-2 text-center mb-2 mini-blog">
                                
                                
                                <div class="row">
                                    <div class="col-12 text-center text-white">
                                        <h6 class="text-warning">{gms.promotion_name}</h6>
                                        {#if gms.promotion_image!=''}
                                        <img class="img-fluid" src="{gms.promotion_image}" />
                                        {:else}
                                        {gms.promotion_desc}
                                        {/if}
                                        
                                        
                                    </div>
                                    <div class="col-6 ">
                                        <button type="button" class="btn btn-dark btn-sm border-1 border-warning w-100 mb-2" on:click={() => push('/promotion/'+gms._id)}>รายละเอียด</button>
                                    </div>
                                    <div class="col-6 ">
                                        <button type="button" class="btn btn-warning btn-sm w-100" on:click={() => push('/promotion/'+gms._id)}>รับโปรโมชั่น</button>
                                    </div>
                                </div>
                            </div>
                            {/each}
                            {/if}
                        </div>
                        
                    </div>
                </div>
                {/if}
        </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
</style>